<template>
    <div id="products-list">
        <b-overlay :show="showLoading" spinner-variant="primary">
            <b-card>
                <ag-grid :agGrid="agGrid" pageTitle="Liste des articles" @refresh="loadData" />
            </b-card>
        </b-overlay>
    </div>
</template>

<script>

import AgGrid from "@/views/components/ag-grid/AgGrid.vue"
import BadgeCellRenderer from "../components/ag-grid/BadgeCellRenderer.vue";
import ButtonCellRenderer from "@/views/components/ag-grid/ButtonCellRenderer.vue"
import { formatPrice } from "@/utils/formatting";

export default {
    components: {
        AgGrid,
    },
    data() {
        return {
            showLoading: false,
            agGrid: {
                columnDefs: [
                    {
                        headerName: "N°",
                        field: "No",
                        width: 100
                    },
                    {
                        headerName: "Description",
                        field: "Description",
                    },
                    {
                        headerName: "Fournisseur",
                        field: "Nom_Fournisseur",
                    },
                    {
                        headerName: "Famille",
                        field: "Family",
                        cellRendererFramework: 'badgeCellRenderer',
                        cellRendererParams: { componentName: "ProductsList", columnName: "Family" },
                        width: 100
                    },
                    {
                        headerName: "Prix H.T",
                        field: "Unit_Price_pharmacien",
                        valueGetter: function (tr) {
                            if (tr.data.No != "")
                                return formatPrice(tr.data.Unit_Price_pharmacien);
                        },
                        width: 100
                    },
                    {
                        headerName: "Prix T.T.C",
                        field: "Unit_Price_pharmacien_TTC",
                        valueGetter: function (tr) {
                            if (tr.data.No != "")
                                return formatPrice(tr.data.Unit_Price_pharmacien_TTC);
                        },
                        width: 100
                    },
                    {
                        headerName: "Prix public",
                        field: "Prix_Public",
                        valueGetter: function (tr) {
                            if (tr.data.No != "")
                                return formatPrice(tr.data.Prix_Public);
                        },
                        width: 100
                    },
                    {
                        headerName: "D.L.C",
                        field: "DLC",
                        width: 100
                    },
                    {
                        headerName: "Cartonnage",
                        field: "Packaging",
                        width: 70
                    },
                    {
                        sortable: false,
                        resizable: false,
                        filter: false,
                        cellClass: 'centered-customeCellRender',
                        cellRendererFramework: 'buttonCellRenderer',
                        cellRendererParams: { onButtonClick: this.showDetails, icon: "more" },
                        headerName: '',
                        width: 70
                    },
                ],
                rows: []
            },
        }
    },
    computed: {
        tableData() {
            return this.$store.getters["app-portaldata/getProducts"];
        },
    },
    watch: {
        tableData(products) {
            let prods = [...products];
            if (products.length > 0) {
                this.showLoading = false;
                this.agGrid.rows = prods.sort((a, b) => {
                    const descriptionA = a.Description.toUpperCase();
                    const descriptionB = b.Description.toUpperCase();

                    if (descriptionA < descriptionB) {
                        return -1;
                    }
                    if (descriptionA > descriptionB) {
                        return 1;
                    }
                    return 0;
                });
            }
        },
    },
    created() {
        this.$options.components.badgeCellRenderer = BadgeCellRenderer;
        this.$options.components.buttonCellRenderer = ButtonCellRenderer;
        let prods = [...this.$store.getters["app-portaldata/getProducts"]];
        if (prods.length > 0) {
            this.agGrid.rows = prods.sort((a, b) => {
                const descriptionA = a.Description.toUpperCase();
                const descriptionB = b.Description.toUpperCase();

                if (descriptionA < descriptionB) {
                    return -1;
                }
                if (descriptionA > descriptionB) {
                    return 1;
                }
                return 0;
            });
        }
    },
    methods: {
        showDetails(data) {
            this.$router.push('/product/' + data.No)
        },
        loadData() {
            this.showLoading = true;
            this.$store.dispatch('app-portaldata/INITIALIZE_PRODUCTS_LIST');
        }
    }
}
</script>

<style lang="scss"></style>
